// this file is generated by update_shopify_store_data.py at 2026-05-26 20:29:08.321132
var courses = [
    {
        "course_id": "7AD46538-27BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "Planetary Health in Clinical Practice: Advocating for Patients in a Changing World",
        "course_type": 1,
        "author_information": "Carol Zigler, DNP, FNP-C, APHN-BC",
        "description": "As the climate crisis accelerates, clinicians are uniquely positioned to address its health impacts at every level\u2014from the exam room to health systems. This course equips healthcare professionals with the knowledge and tools to recognize environmental drivers of illness, apply Planetary Health principles in clinical care, and promote sustainable, equitable practices that benefit both patients and the planet. Through practical strategies, real-world examples, and a focus on advocacy, learners will gain a clear understanding of how to take meaningful action in a changing world.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ol>Define Planatary Health and explain its relevance to clinical care; </ol>\r\n    <ol>Recognize how environmental and climate-related factors contribute to patient risk and outcomes; </ol>\r\n        <ol>Identify opportunities to deliver care that supports both health and sustainability; </ol>\r\n            <ol>Understand the role of climate justice in addressing health dispartities; </ol>\r\n                <ol>Advocate for your patients by intergrating Planetary Health principles into your everyday practice.\r\n                </ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "54BD2843-F7D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Planetary Health in Clinical Practice: Advocating for Patients in a Changing World",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Personal Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "809D92BA-F5D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: Planetary Health in Clinical Practice: Advocating for Patients in a Changing World",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 0.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];